/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
  useMemo,
} from 'react'
import { connect, ReactReduxContext } from 'react-redux'
import styled from '@emotion/styled'
import R from 'ramda'
import {
  Input,
  DatePicker,
  Select,
  Switch,
  Col,
  Row,
  Button,
  Divider,
  Radio,
  Checkbox,
  Icon,
  Modal,
  message,
} from 'antd'
import moment from 'moment'
import { NYISO_CLIENT } from '../../src/client'
import {
  getApiTargetInfo,
  getUnits,
  getPermitActions,
  getEnvConfig,
  getUserInfo,
  getCauseCodeMap,
  getEventTypes,
} from 'core'
import { hasAccesPermits, sortStringArray } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import {
  getDataItems,
  postAdhocRptUnitGroup,
  postAdhocRptDataGroup,
  getAdhocRptUnitGroups,
  getAdhocRptDataGroups,
  getAdhocCausecodeGroups,
  postAdhocRptCausecodeGroup,
  // getReportMessages,
  exportAdhocReportPdf,
  exportAdhocReportXlsx,
  runAdhocReportInBackground,
  deleteAdhocUnitGroup,
  deleteAdhocDataItemGroup,
  deleteAdhocCauseCodeGroup,
  getAdhocData,
  getSystemConfigurationInfo,
  getCauseCodeAll,
} from 'api/pgads'
import { Content, FullHeightSizer } from 'core/screen-util'
import CauseCodePrompt from '../card-data/MultiCauseCode'
import './adhoc-report.css'
import SelectEvents from './SelectEvents'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'
// import { loadDataForDate, setTransDate } from 'core/actions'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import { getClientInfo } from '../core/selectors'
import { getAllUnitsByUser } from '../api/pgads'

const dateOptions = {
  Custom: [
    moment()
      .subtract(1, 'month')
      .startOf('month'),
    moment()
      .subtract(1, 'month')
      .endOf('month'),
  ],
  'Current Month': [moment().startOf('month'), moment().endOf('month')],
  'Previous Month': [
    moment()
      .subtract(1, 'months')
      .startOf('month'),
    moment()
      .subtract(1, 'months')
      .endOf('month'),
  ],
  'Current Year': [moment().startOf('year'), moment().endOf('year')],
  'Previous Year': [
    moment()
      .subtract(1, 'years')
      .startOf('year'),
    moment()
      .subtract(1, 'years')
      .endOf('year'),
  ],
  'Year to Date': [moment().startOf('year'), moment()],
  'Month to Date': [moment().startOf('month'), moment()],
  'Year to Last Month': [
    moment().startOf('year'),
    moment()
      .subtract(1, 'months')
      .endOf('month'),
  ],
  'Trailing Twelve Month': [
    moment()
      .endOf('month')
      .add(1, 'days')
      .subtract(1, 'years'),
    moment().endOf('month'),
  ],
  'Complete Year': [
    moment()
      .subtract(1, 'years')
      .startOf('year'),
    moment()
      .subtract(1, 'years')
      .endOf('year'),
  ],
  'First Quarter': [
    moment()
      .quarter(1)
      .startOf('quarter'),
    moment()
      .quarter(1)
      .endOf('quarter'),
  ],
  'Second Quarter': [
    moment()
      .quarter(2)
      .startOf('quarter'),
    moment()
      .quarter(2)
      .endOf('quarter'),
  ],
  'Third Quarter': [
    moment()
      .quarter(3)
      .startOf('quarter'),
    moment()
      .quarter(3)
      .endOf('quarter'),
  ],
  'Fourth Quarter': [
    moment()
      .quarter(4)
      .startOf('quarter'),
    moment()
      .quarter(4)
      .endOf('quarter'),
  ],
}

const Label = styled.span`
  display: ${props => (props.inline ? 'inline' : 'block')};
  margin-bottom: 5px;
  font-weight: 600;
`

const LabelDate = styled.span`
  display: ${props => (props.inline ? 'inline' : 'block')};
  margin-bottom: 5px;
  font-weight: 600;
  display: grid;
  align-content: end;
`
const ReportIcon = ({ type, disabled, toolTip, onClick }) => (
  <span
    title={toolTip}
    css={{ cursor: disabled ? 'not-allowed' : 'pointer', alignSelf: 'center' }}
    onClick={!disabled ? onClick : null}
  >
    <Icon
      type={type}
      theme={`${disabled ? '' : 'twoTone'}`}
      css={{ marginLeft: 5, fontSize: 20, verticalAlign: 'middle' }}
    />
  </span>
)

const ReorderableOptionValue = ({
  label,
  selectionIndex,
  selectedCount,
  onReorder,
}) => {
  const [over, setOver] = React.useState(false)
  return (
    <div
      onMouseEnter={() => setOver(true)}
      onMouseLeave={() => setOver(false)}
      style={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {label}
      <Icon
        type="up-circle"
        theme={`${selectionIndex ? 'twoTone' : ''}`}
        style={{
          visibility: `${over && selectionIndex >= 0 ? 'inherit' : 'hidden'}`,
          marginRight: '3px',
          marginLeft: 'auto',
          alignSelf: 'center',
          fontSize: '18px',
        }}
        onClick={e => {
          e.stopPropagation()
          if (over && selectionIndex) {
            onReorder(selectionIndex, selectionIndex - 1)
          }
        }}
      />
      <Icon
        type="down-circle"
        theme={`${selectionIndex < selectedCount - 1 ? 'twoTone' : ''}`}
        style={{
          visibility: `${over && selectionIndex >= 0 ? 'inherit' : 'hidden'}`,
          alignSelf: 'center',
          fontSize: '18px',
        }}
        onClick={e => {
          e.stopPropagation()
          if (selectionIndex >= 0 && selectionIndex < selectedCount - 1) {
            onReorder(selectionIndex, selectionIndex + 1)
          }
        }}
      />
    </div>
  )
}

const NewGroupModal = ({ onOk, onCancel, placeholder }) => {
  const [name, setName] = useState('')
  return (
    <Modal
      title="Save to New Group"
      width="300px"
      visible
      onOk={name ? () => onOk(name) : null}
      okText="Done"
      onCancel={onCancel}
      centered
      maskClosable={false}
    >
      <Label>New group name</Label>
      <Input
        placeholder={placeholder}
        value={name}
        onChange={e => setName(e.target.value)}
      />
    </Modal>
  )
}

const customOption = () => <Select.Option value="Custom">Custom</Select.Option>
const allSelectOption = () => <Select.Option value="All">All</Select.Option>

const unitCodeList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.unitName}`, a.id1])
)

const AdhocReport = ({
  apiTargetInfo,
  // unitList,
  unitListByDate,
  actionPermits,
  envConfig,
  // setDate,
  userInfo,
  causeCodeMapProp,
  eventTypes,
  CLIENT,
}) => {
  const isNYISO = useMemo(_ => CLIENT === NYISO_CLIENT, [CLIENT])

  const causecodeMap = useRef({})
  const generatedOn = useRef()
  const { setSelectedDateRagePicker } = useContext(DatePickerContext)

  const setDate = (d1, d2) => setSelectedDateRagePicker([d1, d2])

  const [availableDataItems, setAvailableDataItems] = useState([])
  const [template, setTemplate] = useState('')
  const [dateFilter, setDateFilter] = useState({
    type: 'Custom',
    range: [dateOptions.Custom[0], dateOptions.Custom[1]],
  })

  const [nyisoUnits, setNyisoUnits] = useState([])
  /*
  NYISO want to se all unit by user , no matter if its active or not commissned
  */
  const showAllUnitsByUser = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ADHOC_SHOW_ALL_UNITS_BYUSER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const sortByNameCaseInsensitive = useMemo(
    _ => R.sortBy(R.compose(R.toLower, R.prop('unitName'))),
    []
  )

  useEffect(
    _ => {
      if (showAllUnitsByUser) {
        getAllUnitsByUser(apiTargetInfo).fork(
          _ => _,
          data => {
            const sortData = sortByNameCaseInsensitive(data)
            setNyisoUnits(sortData)
          }
        )
      } else setNyisoUnits([])
    },
    [apiTargetInfo, showAllUnitsByUser, sortByNameCaseInsensitive]
  )

  const unitList = useMemo(
    _ => {
      const curList = showAllUnitsByUser ? nyisoUnits : unitListByDate
      return curList
    },
    [showAllUnitsByUser, nyisoUnits, unitListByDate]
  )

  const [mocShow, setMocShow] = useState()

  const hideCalcMethod = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ADHOC_HIDE_CALC_METHOD],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const defaultCalcMethodISO = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ADHOC_CALC_METHOD_ISO],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const [basicOptions, setBasicOptions] = useState({
    nercpjm: defaultCalcMethodISO ? 1 : 2,
    omc: 1,
    detailRollup: 0,
    grand: false,
    incexc: '0',
    includeEvent: false,
    entityBase: null,
    timeBase: null,
    sortBy: 'MONTH',
  })
  const [itemsData, setItemsData] = useState({
    selected: [],
    currentGroup: 'Custom',
    availableGroups: {},
    sortBy: 'D',
  })
  const [unitData, setUnitData] = useState({
    selected: [],
    currentGroup: 'Custom',
    availableGroups: {},
  })
  const [showCauseCodeDialog, setShowCauseCodeDialog] = useState(false)
  const [showExcludeEvents, setShowExcludeEvents] = useState(false)
  const [eventTypeData, setEventTypeData] = useState({ selected: [] })
  const [causeCodeData, setCauseCodeData] = useState({
    selected: { selectedKeys: [], causeCodes: [] },
    currentGroup: 'Custom',
    availableGroups: {},
  })
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  // const [excludedEvents, setExcludedEvents] = useState([])
  const [excludedEventsValueMap, setExcludeEventsValueMap] = useState({})
  const excludeEventsValueMapKeyGen = r =>
    `${r.unitName} ${r.year} ${r.eventNum}`
  const [showMessages, setShowMessages] = useState(false)
  const [messages, setMessages] = useState([])

  const setSelectedValue = (value = [], currentState, setterFn) => {
    currentState.selected = value
    setterFn({ ...currentState })
  }

  const setPropertyValue = (name, value, currentState, setterFn) => {
    currentState[name] = value
    setterFn({ ...currentState })
  }

  const initAdhocRptUnitGroups = useCallback(
    () => {
      const byGroupName = R.groupBy(list => list.groupName)
      getAdhocRptUnitGroups(apiTargetInfo)(
        dateFilter.range[1].format('YYYY-MM-DD')
      ).fork(setError, d => {
        const groupByData = byGroupName(d)
        let cunitdata = { ...unitData, showAddSave: true }

        if (unitData.currentGroup !== 'Custom') {
          if (!d.some(g => g.groupName === unitData.currentGroup)) {
            cunitdata = { ...cunitdata, selected: [], currentGroup: 'Custom' }
          } else {
            const currentGroupUnits = (
              groupByData[unitData.currentGroup] || []
            ).map(u => u.unitName)
            cunitdata = {
              ...unitData,
              selected: currentGroupUnits,
              showAddSave: true,
            }
          }
        }
        setPropertyValue('availableGroups', groupByData, cunitdata, setUnitData)
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      apiTargetInfo,
      dateFilter.range,
      setError,
      // unitData,
      // unitList,
    ]
  )

  useEffect(initAdhocRptUnitGroups, [initAdhocRptUnitGroups])
  useEffect(
    _ => {
      const us = unitData.selected
      const filUnits = us.filter(s => unitList.find(u => u.unitName === s))
      setSelectedValue(filUnits, unitData, setUnitData)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unitList]
  )

  const initAdhocRptDataGroups = useCallback(
    latFunc => {
      const byGroupName = R.groupBy(list => list.templateName)
      getAdhocRptDataGroups(apiTargetInfo).fork(setError, d => {
        setPropertyValue(
          'availableGroups',
          byGroupName(d),
          itemsData,
          setItemsData
        )
        latFunc && latFunc()
      })
    },
    [apiTargetInfo, setError, itemsData]
  )
  const initAdhocRptCausecodeGroups = useCallback(
    latFunc => {
      const byGroupName = R.groupBy(list => list.templateName)
      getAdhocCausecodeGroups(apiTargetInfo).fork(setError, d => {
        setPropertyValue(
          'availableGroups',
          byGroupName(d),
          causeCodeData,
          setCauseCodeData
        )
        latFunc && latFunc()
      })
    },
    [apiTargetInfo, causeCodeData, setError]
  )
  const [causeCodeList, setCauseCodeList] = useState([])
  useEffect(
    _ => {
      getCauseCodeAll(apiTargetInfo).fork(setError, setCauseCodeList)
    },
    [apiTargetInfo, setError]
  )

  useEffect(() => {
    Object.keys(causeCodeMapProp).forEach(
      c => (causecodeMap.current[c] = `${c}-${causeCodeMapProp[c]}`)
    )
  }, [causeCodeMapProp])

  useEffect(() => {
    getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
      const sysConfigMOCShow = d.find(
        s => s.key === 'INCLUDE_MOC_SHOW' || s.key === 'INCLUDE_OMC_SHOW'
      ) || {
        value: 'YES',
      }

      const sysConfigMOCDefault = d.find(
        s => s.key === 'INCLUDE_MOC_DEFAULT' || s.key === 'INCLUDE_OMC_DEFAULT'
      ) || { value: 'NO' }

      setMocShow(sysConfigMOCShow?.value === 'YES')
      setBasicOptions(prev => ({
        ...prev,
        omc: sysConfigMOCDefault?.value === 'YES' ? 1 : 2,
      }))
      ///   setSolarMissingDataDaysGap(dateRange.value)
    })
  }, [apiTargetInfo, setError])

  useEffect(() => {
    getDataItems(apiTargetInfo).fork(setError, d => {
      setAvailableDataItems(d)
      const allDataItems = d.map(di => ({
        ...di,
        seq: di.defSeq,
        templateName: 'All',
      }))
      const sg = { ...itemsData.availableGroups, All: allDataItems }
      // setItemsData({ ...itemsData, allDataItems })
      setItemsData({ ...itemsData, availableGroups: sg })
    })
    initAdhocRptDataGroups()
    initAdhocRptCausecodeGroups()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    setError,
    apiTargetInfo,
    dateFilter.range,
    // setDate,
    // initAdhocRptDataGroups,
    // initAdhocRptCausecodeGroups,
  ])

  const onCauseCodeDialogClose = (selectedKeys, selectedValues) => {
    setShowCauseCodeDialog(false)
    setPropertyValue('showAddSave', true, causeCodeData, setCauseCodeData)
    setCauseCodeData(prev => ({
      ...prev,
      selected: {
        selectedKeys,
        selectedKeysValues: selectedValues,
        causeCodes: (selectedValues || []).map(s => s.causeCode),
      },
    }))
  }
  const clearCauseCodeList = _ => {
    setCauseCodeData(prev => ({
      ...prev,
      selected: {
        selectedKeys: [],
        selectedKeysValues: [],
        causeCodes: [],
      },
    }))
  }

  const saveUnitGroup = (groupName, selectedUnits) => {
    postAdhocRptUnitGroup(apiTargetInfo)(
      selectedUnits.map(unitName => {
        const unit = unitList.find(u => u.unitName === unitName)
        return { groupName, utility: unit.utility, unit: unit.unit }
      })
    ).fork(setError, () => {
      setPropertyValue('showAddSave', false, unitData, setUnitData)
      message.success(`Changes to group "${groupName}" saved successfully`)
      initAdhocRptUnitGroups()
    })
  }

  const deleteUnitGroup = groupName => {
    Modal.confirm({
      title: 'Delete Unit Group?',
      content: groupName,
      onOk() {
        deleteAdhocUnitGroup(apiTargetInfo)(groupName).fork(setError, _ => {
          message.success(`Unit group "${groupName}" deleted successfully`)
          initAdhocRptUnitGroups()
        })
      },
      onCancel() {},
    })
  }

  const saveDataGroup = (groupName, selectedItems) => {
    postAdhocRptDataGroup(apiTargetInfo)(
      selectedItems.map((ident, i) => ({
        templateName: groupName,
        ident,
        username: 'IntegDevAdmin',
        seq: i + 1,
      }))
    ).fork(setError, () => {
      setPropertyValue('showAddSave', false, itemsData, setItemsData)
      message.success(`Changes to group "${groupName}" saved successfully`)
      initAdhocRptDataGroups()
    })
  }

  const deleteItemGroup = groupName => {
    Modal.confirm({
      title: 'Delete Data items Group?',
      content: groupName,
      onOk() {
        deleteAdhocDataItemGroup(apiTargetInfo)(groupName).fork(setError, _ => {
          message.success(`Data Item group "${groupName}" deleted successfully`)

          const latFunc = _ => {
            setPropertyValue('showAddSave', true, itemsData, setItemsData)
            setSelectedValue([], itemsData, setItemsData)
            setPropertyValue('currentGroup', 'Custom', itemsData, setItemsData)
          }
          initAdhocRptDataGroups(latFunc)
        })
      },
      onCancel() {},
    })
  }

  const deleteCauseCodeGroup = groupName => {
    Modal.confirm({
      title: 'Delete Cause Code Group?',
      content: groupName,
      onOk() {
        deleteAdhocCauseCodeGroup(apiTargetInfo)(groupName).fork(
          setError,
          _ => {
            message.success(
              `Cause Code group "${groupName}" deleted successfully`
            )
            setPropertyValue(
              'currentGroup',
              'Custom',
              causeCodeData,
              setCauseCodeData
            )
            setPropertyValue(
              'showAddSave',
              false,
              causeCodeData,
              setCauseCodeData
            )

            const latFunc = _ =>
              setCauseCodeData({
                ...causeCodeData,
                selected: {
                  selectedKeys: [],
                  causeCodes: [],
                },
              })

            initAdhocRptCausecodeGroups(latFunc)
          }
        )
      },
      onCancel() {},
    })
  }

  const saveCausecodeGroup = (groupName, selectedCausecodes) => {
    postAdhocRptCausecodeGroup(apiTargetInfo)(
      selectedCausecodes.map(cc => ({
        templateName: groupName,
        causecode: cc,
      }))
    ).fork(setError, () => {
      setPropertyValue('showAddSave', false, causeCodeData, setCauseCodeData)
      message.success(`Changes to group "${groupName}" saved successfully`)
      initAdhocRptCausecodeGroups()
    })
  }

  const showReportMessages = (file, typefile, callfunc) => {
    setSpinning(true)
    // getReportMessages
    getAdhocData(apiTargetInfo)(getReportFilters()).fork(setError, data => {
      if ((data.warningError || []).length) {
        setShowMessages(true)
      }
      setMessages(data.warningError || [])
      callfunc(getReportFilters(data))
        .then(blob => {
          setSpinning(false)
          exportData(blob, typefile, file)
        })
        .catch(_ => setSpinning(false))
    })
  }

  const getReportFilters = oldData => {
    const units = unitData.selected.map(s => {
      const selectedUnit = unitList.find(u => u.unitName === s)
      return { utility: selectedUnit.utility, unit: selectedUnit.unit }
    })
    generatedOn.current = new Date()
    const data = {
      oldData: oldData,
      template: template || 'Ad Hoc Report',
      from: dateFilter.range[0].format('MM/DD/YYYY'),
      to: dateFilter.range[1].format('MM/DD/YYYY'),
      ...basicOptions,
      includeEvent: basicOptions.detailRollup,
      dataItems: itemsData.selected,
      units,
      causeCodes: causeCodeData.selected.causeCodes.map(c => ({
        code: c,
        desc: causecodeMap.current[c],
      })),
      eventTypes: eventTypeData.selected.flatMap(d =>
        eventTypes
          .filter(e => d === e.eventType)
          .map(e => ({ type: e.eventType, desc: e.description }))
      ),
      excludedEvents: Object.values(excludedEventsValueMap || {}),
      generatedOn: generatedOn.current.getTime(),
    }
    return data
  }

  const exportData = (blob, type, fileName) => {
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob, { type })
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const isValidFileName = _ => {
    if (template) {
      if (
        template.includes('\\') ||
        template.includes('/') ||
        template.includes(':') ||
        template.includes('*') ||
        template.includes('?') ||
        template.includes('"') ||
        template.includes('<') ||
        template.includes('>') ||
        template.includes('|')
      ) {
        message.warning(
          <span>
            Report title can't contain any of the following characters
            <div>
              <b>{' \\ / : * ? " < > | '}</b>
            </div>
          </span>,
          10
        )
        return false
      }
    }
    return true
  }

  const runInBackground = fileType => {
    runAdhocReportInBackground(apiTargetInfo)({
      ...getReportFilters(),
      fileName: decodeURIComponent(
        `ADHOC_REPORT_${userInfo.userName}_${moment(generatedOn.current).format(
          'MMDDYYYYHHmmss'
        )}.${fileType}`
      ),
    }).fork(setError, () => {
      message.success('Report generation started in background')
    })
  }

  // below condition is from wing
  const isBackgroundReport =
    basicOptions.detailRollup === 1 &&
    (unitData.selected.length > 1 ||
      dateFilter.range[1].diff(dateFilter.range[0], 'days') > 0)

  // nkhil : as per discution  ,  carly told below condition
  //  const isBackgroundReport =
  //    unitData.selected.length > 50 && dateFilter.range[1].diff(dateFilter.range[0], 'year') > 5

  const { authGodMode } = envConfig

  return (
    <FullHeightSizer heightOffset={100}>
      {({ height }) => (
        <div style={{ overflow: 'auto', height: height + 'px' }}>
          <Content css={{ margin: '20 30', padding: '10 20' }}>
            {showCauseCodeDialog && (
              <CauseCodePrompt
                visibleDialog
                onDialogClose={onCauseCodeDialogClose}
                onCancelAction={() => setShowCauseCodeDialog(false)}
                defaultExpandedKeys={causeCodeData.selected.selectedKeys}
                unitCodes={R.uniq(
                  unitData.selected.map(u => unitCodeList(unitList)[u])
                )}
                multiple
                checkable
                selectable={false}
                causeCodeValue={causeCodeData?.selected?.causeCodes || []}
                causeCodeList={causeCodeList}
                selectedKeys={causeCodeData?.selected?.selectedKeys || []}
                selectedValues={
                  causeCodeData?.selected?.selectedKeysValues || []
                }
              />
            )}
            <center>
              <h2>Ad Hoc Metrics Report</h2>
            </center>

            <Row type="flex" align="bottom" gutter={[24, 16]}>
              <Col span={12}>
                <Label>
                  <span css={{ marginLeft: 5, fontWeight: 800 }}>
                    1. Report Title
                  </span>
                </Label>
                <Input
                  placeholder="Anonymous Report"
                  value={template}
                  onChange={e => setTemplate(e.target.value)}
                />
              </Col>
              <Col span={12}>
                {mocShow && (
                  <>
                    <Label inline css={{ marginRight: 10 }}>
                      Include OMC
                    </Label>
                    <Switch
                      checked={basicOptions.omc === 1}
                      onChange={checked =>
                        setBasicOptions(prev => ({
                          ...prev,
                          omc: checked ? 1 : 2,
                        }))
                      }
                    />
                  </>
                )}
                {!isNYISO && (
                  <>
                    <Label inline css={{ marginLeft: 10, marginRight: 10 }}>
                      Include Event Contributions
                    </Label>
                    <Switch
                      checked={basicOptions.detailRollup === 1}
                      onChange={checked =>
                        setBasicOptions(prev => ({
                          ...prev,
                          detailRollup: checked ? 1 : 0,
                          // includeEventContribution: checked ? 1 : 0,
                        }))
                      }
                    />
                  </>
                )}
              </Col>
            </Row>
            <Row type="flex" align="middle" gutter={[24, 16]}>
              <Col span={12}>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridTemplateRows: '1fr 1fr',
                    gridColumnGap: '5px',
                  }}
                >
                  <LabelDate>
                    <span>{isNYISO ? 'Select Month' : 'Select Dates'}</span>
                  </LabelDate>
                  <LabelDate>
                    <span>{isNYISO ? 'Start Month' : 'Start Date'}</span>
                  </LabelDate>
                  <LabelDate>{isNYISO ? 'End Month' : 'End Date'}</LabelDate>

                  {/* <DateDiv> */}
                  <Select
                    css={{ display: 'content' }}
                    value={dateFilter.type}
                    onChange={v => {
                      setDateFilter({ type: v, range: dateOptions[v] })
                      setDate(dateOptions[v][0], dateOptions[v][1])
                    }}
                  >
                    {Object.keys(dateOptions).map(d => (
                      <Select.Option key={d}>{d}</Select.Option>
                    ))}
                  </Select>
                  {isNYISO ? (
                    <DatePicker.MonthPicker
                      value={dateFilter.range[0]}
                      format="MMM YYYY"
                      onChange={date => {
                        const effectiveDate = moment(date).startOf('month')
                        const endDate = effectiveDate.isAfter(
                          dateFilter.range[1]
                        )
                          ? moment(effectiveDate).endOf('month')
                          : dateFilter.range[1]
                        const range = [effectiveDate, endDate]
                        setDateFilter({ type: 'Custom', range })
                        setDate(date, dateFilter.range[1])
                      }}
                      allowClear={false}
                    />
                  ) : (
                    <DatePicker
                      value={dateFilter.range[0]}
                      format="MM/DD/YYYY"
                      onChange={date => {
                        const endDate = date.isAfter(dateFilter.range[1])
                          ? date
                          : dateFilter.range[1]
                        const range = [date, endDate]
                        setDateFilter({ type: 'Custom', range })
                        setDate(date, endDate)
                      }}
                      allowClear={false}
                    />
                  )}
                  {/* <div
              style={{
                marginLeft: '5px',
                marginRight: '5px',
                display: 'grid',
                alignItems: 'center',
              }}
            >
              To
            </div> */}
                  {isNYISO ? (
                    <DatePicker.MonthPicker
                      value={dateFilter.range[1]}
                      format="MMM YYYY"
                      onChange={date => {
                        const effectiveDate = moment(date).endOf('month')
                        const stDate = effectiveDate.isBefore(
                          dateFilter.range[0]
                        )
                          ? moment(effectiveDate).startOf('month')
                          : dateFilter.range[0]
                        const range = [stDate, effectiveDate]
                        setDateFilter({ type: 'Custom', range })
                        setDate(stDate, effectiveDate)
                      }}
                      allowClear={false}
                    />
                  ) : (
                    <DatePicker
                      value={dateFilter.range[1]}
                      format="MM/DD/YYYY"
                      onChange={date => {
                        const stDate = date.isBefore(dateFilter.range[0])
                          ? date
                          : dateFilter.range[0]
                        const range = [stDate, date]
                        setDateFilter({ type: 'Custom', range })
                        setDate(stDate, date)
                      }}
                      allowClear={false}
                    />
                  )}
                  {/* </DateDiv> */}
                </div>
              </Col>
              <Col
                span={4}
                css={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  maxWidth: '200px',
                  width: '180px',
                  marginRight: '0px',
                }}
              >
                <div>
                  <Label>Sort by</Label>
                  <Radio.Group
                    value={basicOptions.sortBy}
                    onChange={e =>
                      setBasicOptions(prev => ({
                        ...prev,
                        sortBy: e.target.value,
                      }))
                    }
                    buttonStyle="solid"
                  >
                    <Radio value="UNIT">Unit</Radio>
                    <Radio value="MONTH">Month</Radio>
                  </Radio.Group>
                </div>
              </Col>
              <Col span={8} css={{ marginLeft: '0px' }}>
                {!hideCalcMethod && (
                  <React.Fragment>
                    <div>
                      <Label>Calculation Method</Label>
                    </div>
                    <Radio.Group
                      value={basicOptions.nercpjm}
                      onChange={e =>
                        setBasicOptions(prev => ({
                          ...prev,
                          nercpjm: e.target.value,
                        }))
                      }
                      buttonStyle="solid"
                    >
                      <Radio value={2}>NERC</Radio>
                      <Radio value={1}>ISO</Radio>
                    </Radio.Group>
                  </React.Fragment>
                )}
              </Col>
            </Row>
            <Divider>Select Options</Divider>
            <Row gutter={24}>
              <Col span={12}>
                {itemsData.showNewGroupModal && (
                  <NewGroupModal
                    placeholder="Outage Group"
                    onOk={newGrpName => {
                      setPropertyValue(
                        'currentGroup',
                        newGrpName,
                        itemsData,
                        setItemsData
                      )
                      setPropertyValue(
                        'showNewGroupModal',
                        false,
                        itemsData,
                        setItemsData
                      )
                      saveDataGroup(newGrpName, itemsData.selected)
                    }}
                    onCancel={() =>
                      setPropertyValue(
                        'showNewGroupModal',
                        false,
                        itemsData,
                        setItemsData
                      )
                    }
                  />
                )}
                <div style={{ height: '50px' }}>
                  <div
                    css={{
                      display: 'grid',
                      gridTemplateColumns: '100px 200px 20px 20px 20px auto',
                      // flexDirection: 'row',
                      marginBottom: 10,
                      alignItems: 'center',
                      gridColumnGap: '10px',
                      overflowX: 'auto',
                    }}
                  >
                    <Label
                      // inline
                      css={{
                        fontWeight: 800,
                        marginLeft: 5,
                        marginTop: 'auto',
                        display: 'grid',
                        alignContent: 'center',
                        height: '100%',
                      }}
                    >
                      2. Data Items
                    </Label>
                    <Select
                      css={{}}
                      value={itemsData.currentGroup}
                      onChange={v => {
                        setPropertyValue(
                          'currentGroup',
                          v,
                          itemsData,
                          setItemsData
                        )
                        if (v === 'All') {
                          setPropertyValue(
                            'showAddSave',
                            false,
                            itemsData,
                            setItemsData
                          )
                          setSelectedValue(
                            availableDataItems.map(g => g.ident),
                            itemsData,
                            setItemsData
                          )
                          if (!template) {
                            setTemplate(v)
                          }
                        } else if (v !== 'Custom') {
                          setPropertyValue(
                            'showAddSave',
                            false,
                            itemsData,
                            setItemsData
                          )
                          setSelectedValue(
                            itemsData.availableGroups[v].map(g => g.ident),
                            itemsData,
                            setItemsData
                          )
                          if (!template) {
                            setTemplate(v)
                          }
                        } else {
                          setPropertyValue(
                            'showAddSave',
                            true,
                            itemsData,
                            setItemsData
                          )
                          setSelectedValue([], itemsData, setItemsData)
                        }
                      }}
                    >
                      {customOption()}
                      {allSelectOption()}
                      {Object.keys(itemsData.availableGroups).map(g => (
                        <Select.Option key={g}>{g}</Select.Option>
                      ))}
                    </Select>
                    <ReportIcon
                      type="plus-circle"
                      toolTip="Save to New Group"
                      disabled={!itemsData.selected.length}
                      onClick={() =>
                        setPropertyValue(
                          'showNewGroupModal',
                          true,
                          itemsData,
                          setItemsData
                        )
                      }
                    />
                    <ReportIcon
                      type="save"
                      disabled={
                        !itemsData.selected.length ||
                        itemsData.currentGroup === 'Custom'
                      }
                      toolTip="Save to Existing Group"
                      onClick={() =>
                        saveDataGroup(
                          itemsData.currentGroup,
                          itemsData.selected
                        )
                      }
                    />

                    <ReportIcon
                      type="delete"
                      disabled={itemsData.currentGroup === 'Custom'}
                      toolTip="Delete Group"
                      onClick={_ => deleteItemGroup(itemsData.currentGroup)}
                    />
                    {/* <div css={{ marginLeft: '10px', minWidth: 'fitContent' }}>
              Display order
            </div> */}
                    <div
                      css={{
                        // marginLeft: '10px',
                        marginTop: 'auto',
                        marginBottom: '5px',
                      }}
                    >
                      {/* <div style={{ paddingLeft: '10px' }}>Display order</div> */}
                      <Radio.Group
                        css={{
                          // marginLeft: 10,
                          display: 'grid',
                          gridTemplateColumns: '1fr',
                        }}
                        value={itemsData.sortBy}
                        buttonStyle="solid"
                        onChange={e => {
                          setPropertyValue(
                            'sortBy',
                            e.target.value,
                            itemsData,
                            setItemsData
                          )
                          if (e.target.value === 'D') {
                            setAvailableDataItems(
                              availableDataItems.sort(
                                (a, b) =>
                                  parseInt(a.defSeq) - parseInt(b.defSeq)
                              )
                            )
                          } else {
                            setAvailableDataItems(
                              availableDataItems.sort((a, b) =>
                                a.displayName <= b.displayName ? -1 : 1
                              )
                            )
                          }
                        }}
                      >
                        <Radio value="D">Order By default</Radio>
                        <Radio value="A">Order By Alphabetically</Radio>
                      </Radio.Group>
                    </div>
                  </div>
                </div>
                <Select
                  mode="multiple"
                  className="multiple-select-big"
                  placeholder="Select at least one data item"
                  css={{ width: '100%' }}
                  value={itemsData.selected}
                  optionLabelProp="label"
                  optionFilterProp="label"
                  onChange={v => {
                    setPropertyValue(
                      'showAddSave',
                      true,
                      itemsData,
                      setItemsData
                    )
                    setSelectedValue(v, itemsData, setItemsData)
                  }}
                >
                  {availableDataItems.map(i => (
                    <Select.Option
                      key={i.ident}
                      value={i.ident}
                      label={i.displayName}
                    >
                      <ReorderableOptionValue
                        label={i.displayName}
                        selectionIndex={itemsData.selected.findIndex(
                          s => s === i.ident
                        )}
                        selectedCount={itemsData.selected.length}
                        onReorder={(currentIndex, newIndex) => {
                          if (currentIndex !== newIndex) {
                            const items = [...itemsData.selected]
                            const tmp = items[currentIndex]
                            items[currentIndex] = items[newIndex]
                            items[newIndex] = tmp
                            setSelectedValue(items, itemsData, setItemsData)
                          }
                        }}
                      />
                    </Select.Option>
                  ))}
                </Select>
              </Col>
              <Col span={12}>
                {unitData.showNewGroupModal && (
                  <NewGroupModal
                    placeholder="Astoria"
                    onOk={newGrpName => {
                      setPropertyValue(
                        'currentGroup',
                        newGrpName,
                        unitData,
                        setUnitData
                      )
                      setPropertyValue(
                        'showNewGroupModal',
                        false,
                        unitData,
                        setUnitData
                      )
                      saveUnitGroup(newGrpName, unitData.selected)
                    }}
                    onCancel={() =>
                      setPropertyValue(
                        'showNewGroupModal',
                        false,
                        unitData,
                        setUnitData
                      )
                    }
                  />
                )}
                <div
                  style={{
                    height: '50px',
                    display: 'grid',
                    gridTemplateColumns: '80px 200px 25px 25px 25px',
                    gap: '5px',
                  }}
                >
                  <Label
                    inline
                    css={{
                      fontWeight: 800,
                      marginLeft: 5,
                      display: 'grid',
                      alignContent: 'center',
                      marginBottom: '0px',
                    }}
                  >
                    3. Units
                  </Label>
                  <Select
                    css={{
                      width: '100%',
                      marginLeft: 0,
                      display: 'grid',
                      alignContent: 'center',
                      marginBottom: '0px',
                    }}
                    value={unitData.currentGroup}
                    onChange={v => {
                      setPropertyValue('currentGroup', v, unitData, setUnitData)
                      if (v === 'All') {
                        setPropertyValue(
                          'showAddSave',
                          true,
                          unitData,
                          setUnitData
                        )
                        setSelectedValue(
                          unitList.map(u => u.unitName),
                          unitData,
                          setUnitData
                        )
                      } else if (v !== 'Custom') {
                        setPropertyValue(
                          'showAddSave',
                          false,
                          unitData,
                          setUnitData
                        )
                        setSelectedValue(
                          unitData.availableGroups[v].map(g => g.unitName),
                          unitData,
                          setUnitData
                        )
                      } else {
                        setPropertyValue(
                          'showAddSave',
                          true,
                          unitData,
                          setUnitData
                        )
                        setSelectedValue([], unitData, setUnitData)
                      }
                    }}
                  >
                    {customOption()}
                    {allSelectOption()}
                    {sortStringArray(Object.keys(unitData.availableGroups)).map(
                      g => (
                        <Select.Option key={g}>{g}</Select.Option>
                      )
                    )}
                  </Select>

                  <ReportIcon
                    type="plus-circle"
                    disabled={!unitData.selected.length}
                    toolTip="Save to New Group"
                    onClick={() =>
                      setPropertyValue(
                        'showNewGroupModal',
                        true,
                        unitData,
                        setUnitData
                      )
                    }
                    style={{ marginLeft: '10px' }}
                  />
                  <ReportIcon
                    type="save"
                    disabled={
                      !unitData.selected.length ||
                      unitData.currentGroup === 'Custom'
                    }
                    toolTip="Save to Existing Group"
                    onClick={() =>
                      saveUnitGroup(unitData.currentGroup, unitData.selected)
                    }
                  />
                  <ReportIcon
                    type="delete"
                    disabled={unitData.currentGroup === 'Custom'}
                    toolTip="Delete Group"
                    onClick={_ => deleteUnitGroup(unitData.currentGroup)}
                  />
                </div>
                <Select
                  mode="multiple"
                  className="multiple-select-big"
                  css={{ width: '100%' }}
                  placeholder="Select at least one unit"
                  value={unitData.selected}
                  onChange={v => {
                    setPropertyValue('showAddSave', true, unitData, setUnitData)
                    setSelectedValue(v, unitData, setUnitData)
                  }}
                >
                  {unitList.map(u => (
                    <Select.Option key={u.unitName}>{u.unitName}</Select.Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row type="flex" align="bottom" gutter={24} css={{ marginTop: 20 }}>
              <Col span={8}>
                {causeCodeData.showNewGroupModal && (
                  <NewGroupModal
                    placeholder="Plant outage"
                    onOk={newGrpName => {
                      setPropertyValue(
                        'currentGroup',
                        newGrpName,
                        causeCodeData,
                        setCauseCodeData
                      )
                      setPropertyValue(
                        'showNewGroupModal',
                        false,
                        causeCodeData,
                        setCauseCodeData
                      )
                      saveCausecodeGroup(
                        newGrpName,
                        causeCodeData.selected.causeCodes
                      )
                    }}
                    onCancel={() =>
                      setPropertyValue(
                        'showNewGroupModal',
                        false,
                        causeCodeData,
                        setCauseCodeData
                      )
                    }
                  />
                )}
                <Label inline css={{ fontWeight: 800, marginLeft: 5 }}>
                  4. Cause Codes
                </Label>
                <Select
                  css={{ width: 120, marginLeft: 10, marginBottom: 10 }}
                  value={causeCodeData.currentGroup}
                  disabled={!unitData.selected.length}
                  onChange={v => {
                    setPropertyValue(
                      'currentGroup',
                      v,
                      causeCodeData,
                      setCauseCodeData
                    )
                    if (v !== 'Custom') {
                      setPropertyValue(
                        'showAddSave',
                        false,
                        causeCodeData,
                        setCauseCodeData
                      )
                      const selectedValues = causeCodeData.availableGroups[v]
                        .map(g => g.causecode)
                        .map(c => causeCodeList.find(cl => cl.causeCode === c))
                      setCauseCodeData(prev => ({
                        ...prev,
                        selected: {
                          selectedKeys: causeCodeData.availableGroups[v].map(
                            g => causecodeMap.current[g.causecode]
                          ),
                          selectedKeysValues: selectedValues,
                          causeCodes: causeCodeData.availableGroups[v].map(
                            g => g.causecode
                          ),
                        },
                      }))
                    } else {
                      setPropertyValue(
                        'showAddSave',
                        true,
                        causeCodeData,
                        setCauseCodeData
                      )
                      setCauseCodeData(prev => ({
                        ...prev,
                        selected: {
                          selectedKeys: [],
                          causeCodes: [],
                        },
                      }))
                    }
                  }}
                >
                  {customOption()}
                  {sortStringArray(
                    Object.keys(causeCodeData.availableGroups)
                  ).map(g => (
                    <Select.Option key={g}>{g}</Select.Option>
                  ))}
                </Select>
                <React.Fragment>
                  <ReportIcon
                    type="plus-circle"
                    toolTip="Save to New Group"
                    disabled={!causeCodeData.selected.causeCodes.length}
                    onClick={() =>
                      setPropertyValue(
                        'showNewGroupModal',
                        true,
                        causeCodeData,
                        setCauseCodeData
                      )
                    }
                  />
                  <ReportIcon
                    type="save"
                    disabled={
                      !causeCodeData.selected.causeCodes.length ||
                      causeCodeData.currentGroup === 'Custom'
                    }
                    toolTip="Save to Existing Group"
                    onClick={() =>
                      saveCausecodeGroup(
                        causeCodeData.currentGroup,
                        causeCodeData.selected.causeCodes
                      )
                    }
                  />
                  <ReportIcon
                    type="delete"
                    disabled={causeCodeData.currentGroup === 'Custom'}
                    toolTip="Delete Cause Code Group"
                    onClick={_ =>
                      deleteCauseCodeGroup(causeCodeData.currentGroup)
                    }
                  />
                </React.Fragment>
                <Radio.Group
                  css={{ marginLeft: 10 }}
                  value={basicOptions.incexc}
                  buttonStyle="solid"
                  onChange={e =>
                    setBasicOptions(prev => ({
                      ...prev,
                      incexc: e.target.value,
                    }))
                  }
                >
                  <Radio value="0">Inc</Radio>
                  <Radio value="1">Exc</Radio>
                  <Button onClick={clearCauseCodeList}>Clear All</Button>
                </Radio.Group>
                <div
                  className="ar-causecode"
                  onClick={
                    unitData.selected.length
                      ? () => setShowCauseCodeDialog(true)
                      : null
                  }
                >
                  <Select
                    mode="multiple"
                    className="multiple-select-med"
                    css={{ width: '100%' }}
                    placeholder="All Cause Codes included"
                    value={causeCodeData.selected.causeCodes
                      .slice(0, 30)
                      .map(c => causecodeMap.current[c])}
                    notFoundContent=""
                    disabled={!unitData.selected.length}
                  />
                </div>
              </Col>
              <Col span={8}>
                {showExcludeEvents && (
                  <SelectEvents
                    eventTypes={eventTypes}
                    fromDate={dateFilter.range[0]}
                    units={unitList.filter(u =>
                      (unitData.selected || []).includes(u.unitName)
                    )}
                    apiTargetInfo={apiTargetInfo}
                    onOk={selectedEvents => {
                      // setExcludedEvents(prev => [...prev, ...selectedEvents])
                      //                const keymap = []
                      // const keymap = R.compose(
                      //   // R.reduce((a, b) => ({ ...a, ...b }), {}),

                      //   r => [excludeEventsValueMapKeyGen(r), r]
                      // )()

                      const keymap = R.concat(
                        // excludedEvents,
                        Object.values(excludedEventsValueMap),
                        selectedEvents
                      ).map(k => ({ [excludeEventsValueMapKeyGen(k)]: k }))
                      setExcludeEventsValueMap(
                        R.reduce((a, b) => ({ ...a, ...b }), {}, keymap)
                      )
                      setShowExcludeEvents(false)
                    }}
                    onCancel={() => setShowExcludeEvents(false)}
                    setError={setError}
                    minYear={dateFilter.range[0].format('YYYY')}
                    maxYear={dateFilter.range[1].format('YYYY')}
                  />
                )}
                <div css={{ marginBottom: 10 }}>
                  <Label inline css={{ fontWeight: 800, marginLeft: 5 }}>
                    5. Exclude Events
                  </Label>
                </div>
                <div
                  onClick={
                    unitData.selected.length
                      ? () => setShowExcludeEvents(true)
                      : null
                  }
                >
                  <Select
                    mode="multiple"
                    className="multiple-select-med"
                    css={{ width: '100%' }}
                    placeholder="All events included"
                    // value={excludedEvents.map(
                    //   r => `${r.unitName} ${r.year} ${r.eventNum}`
                    // )}
                    // value={excludedEvents}
                    value={Object.keys(excludedEventsValueMap)}
                    notFoundContent=""
                    disabled={!unitData.selected.length}
                    onChange={v => {
                      // setExcludedEvents(v)
                      const data = R.reduce(
                        (a, b) => ({ ...a, ...b }),
                        {},
                        Object.keys(excludedEventsValueMap)
                          .filter(k => v.includes(k))
                          .map(k => ({ [k]: excludedEventsValueMap[k] }))
                      )
                      setExcludeEventsValueMap(data)
                    }}
                  />
                </div>
              </Col>
              <Col span={8}>
                <div css={{ marginBottom: 10, gap: 10, display: 'flex' }}>
                  <Label
                    inline
                    css={{
                      fontWeight: 800,
                      marginLeft: 5,
                      alignContent: 'end',
                    }}
                  >
                    6. Filter by Event Type
                  </Label>
                  <Button
                    onClick={_ => {
                      setSelectedValue(
                        eventTypes.map(v => v.eventType),
                        eventTypeData,
                        setEventTypeData
                      )
                    }}
                  >
                    Select All
                  </Button>
                  <Button
                    onClick={_ => {
                      setSelectedValue([], eventTypeData, setEventTypeData)
                    }}
                  >
                    Clear All
                  </Button>
                </div>
                <Select
                  mode="multiple"
                  className="multiple-select-med"
                  css={{ width: '100%' }}
                  placeholder="All event types included"
                  value={eventTypeData.selected}
                  onChange={v => {
                    if (v.includes('All')) {
                      setSelectedValue(
                        eventTypes.map(v => v.eventType),
                        eventTypeData,
                        setEventTypeData
                      )
                    } else
                      setSelectedValue(
                        v.filter(d => d !== 'All'),
                        eventTypeData,
                        setEventTypeData
                      )
                  }}
                >
                  {/* {allSelectOption()} */}
                  {eventTypes.map(ev => (
                    <Select.Option key={ev.eventType}>
                      {ev.eventType}-{ev.description}
                    </Select.Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row type="flex" align="bottom" gutter={24} css={{ marginTop: 5 }}>
              <Col span={12}>
                <Divider>Roll-up Options</Divider>
                <Checkbox
                  css={{ marginRight: 10 }}
                  checked={basicOptions.grand}
                  onChange={e =>
                    setBasicOptions(prev => ({
                      ...prev,
                      grand: e.target.checked,
                    }))
                  }
                />
                <Label inline>Show Grand Total</Label>&nbsp;&nbsp;(Roll-up of
                all Units for entire period)
              </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: 10 }}>
              <Col span={12}>
                <Checkbox
                  checked={Boolean(basicOptions.timeBase)}
                  onChange={e => {
                    setBasicOptions(prev => ({
                      ...prev,
                      timeBase: e.target.checked ? 'M' : null,
                    }))
                  }}
                />
                <Label inline css={{ marginLeft: 10 }}>
                  Time Based
                </Label>
                &nbsp;&nbsp;(Roll-up of all Units by Month or Year)&nbsp;&nbsp;
                <Radio.Group
                  value={basicOptions.timeBase}
                  onChange={e =>
                    setBasicOptions(prev => ({
                      ...prev,
                      timeBase: e.target.value,
                    }))
                  }
                  buttonStyle="solid"
                  disabled={!basicOptions.timeBase}
                >
                  <Radio value="M">Month</Radio>
                  <Radio value="Y">Year</Radio>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: 10 }}>
              <Col span={12}>
                <Checkbox
                  checked={Boolean(basicOptions.entityBase)}
                  onChange={e => {
                    setBasicOptions(prev => ({
                      ...prev,
                      entityBase: e.target.checked ? 'U' : null,
                    }))
                  }}
                />
                <Label inline css={{ marginLeft: 10 }}>
                  Entity Based
                </Label>
                {!isNYISO && (
                  <>
                    &nbsp;&nbsp;(Roll-up by Unit or Station for entire
                    period)&nbsp;&nbsp;
                    <Radio.Group
                      value={basicOptions.entityBase}
                      onChange={e =>
                        setBasicOptions(prev => ({
                          ...prev,
                          entityBase: e.target.value,
                        }))
                      }
                      buttonStyle="solid"
                      disabled={!basicOptions.entityBase}
                    >
                      <Radio value="U">Unit</Radio>
                      <Radio value="S">Station</Radio>
                    </Radio.Group>
                  </>
                )}
              </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: 10 }}>
              <Col span={12}>
                <Checkbox
                  checked={Boolean(basicOptions.weight)}
                  onChange={e =>
                    setBasicOptions(prev => ({
                      ...prev,
                      weight: e.target.checked ? 'NETMAXCAP' : null,
                      WEIGHTRATESFECTOR: 'N',
                    }))
                  }
                />
                <Label inline css={{ marginLeft: 10, marginRight: 20 }}>
                  Weighted by
                </Label>
                <Radio.Group
                  value={basicOptions.weight}
                  onChange={e =>
                    setBasicOptions(prev => ({
                      ...prev,
                      weight: e.target.value,
                    }))
                  }
                  buttonStyle="solid"
                >
                  <Radio value="NETMAXCAP">Net Max Cap</Radio>
                  {!isNYISO && (
                    <>
                      <Radio value="NETDEPCAP">Net Dep Cap</Radio>
                      <Radio value="COMPLEX">Complex Net Dep Cap</Radio>
                    </>
                  )}
                </Radio.Group>
                <Checkbox
                  disabled={!basicOptions.weight}
                  checked={basicOptions.WEIGHTRATESFECTOR === 'Y'}
                  onChange={e =>
                    setBasicOptions(prev => ({
                      ...prev,
                      WEIGHTRATESFECTOR: e.target.checked ? 'Y' : 'N',
                    }))
                  }
                >
                  Apply Weight to Rates and Factors Only
                </Checkbox>
              </Col>
              <Col
                span={12}
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: 'auto',
                }}
              >
                {isBackgroundReport && (
                  <div>
                    <h4 css={{ color: 'red', textAlign: 'right' }}>
                      Current selection is expected to take time so report will
                      be generated in background.
                    </h4>
                  </div>
                )}
                <div css={{ marginLeft: 'auto' }}>
                  <Button
                    type="primary"
                    disabled={
                      itemsData.selected.length === 0 ||
                      unitData.selected.length === 0 ||
                      !hasAccesPermits({
                        authGodMode,
                        actionPermits,
                        eventActions: [
                          ScreenPermissions.REPORT_ADHOCK_ACCESS_PDF,
                        ],
                        matchAny: true,
                      })
                    }
                    onClick={() => {
                      if (!isValidFileName()) return
                      if (isBackgroundReport) {
                        runInBackground('pdf')
                      } else {
                        const file = decodeURIComponent(
                          `${userInfo.userName}_adhocreport_${moment(
                            generatedOn.current
                          ).format('MMDDYYYYHHmmssZZ')}.pdf`
                        )

                        showReportMessages(
                          file,
                          'application/pdf',
                          exportAdhocReportPdf(apiTargetInfo)
                        )
                      }
                    }}
                  >
                    Generate PDF
                  </Button>
                  <Button
                    type="primary"
                    style={{ marginLeft: '5px' }}
                    disabled={
                      itemsData.selected.length === 0 ||
                      unitData.selected.length === 0 ||
                      !hasAccesPermits({
                        authGodMode,
                        actionPermits,
                        eventActions: [
                          ScreenPermissions.REPORT_ADHOCK_ACCESS_EXCEL,
                        ],
                        matchAny: true,
                      })
                    }
                    onClick={() => {
                      if (!isValidFileName()) return
                      if (isBackgroundReport) {
                        runInBackground('xlsx')
                      } else {
                        const file = decodeURIComponent(
                          `${userInfo.userName}_adhocreport_${moment(
                            generatedOn.current
                          ).format('MMDDYYYYHHmmssZZ')}.xlsx`
                        )
                        showReportMessages(
                          file,
                          'application/xlsx',
                          exportAdhocReportXlsx(apiTargetInfo)
                        )
                      }
                    }}
                  >
                    Generate Excel
                  </Button>
                </div>
              </Col>
            </Row>

            {showMessages && (
              <JcTmpErrorDialog
                errors={messages}
                visible={showMessages}
                closeErrorPrompt={_ => setShowMessages(false)}
                title="Error/Warning"
              />
            )}
          </Content>
        </div>
      )}
    </FullHeightSizer>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  unitListByDate: getUnits(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  userInfo: getUserInfo(state),
  causeCodeMapProp: getCauseCodeMap(state),
  eventTypes: getEventTypes(state),
  CLIENT: getClientInfo(state),
})

export default connect(
  mapStateToProps
  // ,{ setDate: loadDataForDate }
)(AdhocReport)
